import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Service from '@/pages/Service'
import Message from '@/pages/Message'
import Xiaohui from '@/pages/Xiaohui'
import Mine from '@/pages/Mine'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import ForgotPassword from '@/pages/ForgotPassword'
import ShowCert from '@/pages/ShowCert'
import MyAuth from '@/pages/MyAuth'
import ChangePassword from '@/pages/ChangePassword'
import ChangePhone from '@/pages/ChangePhone'
import DocPage from '@/pages/DocPage'
import About from '@/pages/About'
import SvcPage from '@/pages/SvcPage'
import LaborDisputeMediation from '@/pages/LaborDisputeMediation'
import svcPages from '@/data/svcPages'
import Settings from '@/pages/Settings'
import SocialCardQuery from '@/pages/SocialCardQuery'
import SearchPage from '@/pages/SearchPage'
import Pension from '@/pages/Pension'
import RuralPension from '@/pages/RuralPension'
import Injury from '@/pages/Injury'
import SocialCard from '@/pages/SocialCard'
import OneThing from '@/pages/OneThing'
import CaseList from '@/pages/CaseList'
import Salary from '@/pages/Salary'
import InfoVerify from '@/pages/InfoVerify'
import SkillCert from '@/pages/SkillCert'
import ComputerCert from '@/pages/ComputerCert'
import MapService from '@/pages/MapService'
import Graduate from '@/pages/Graduate'
import Elderly from '@/pages/Elderly'
import ResidentService from '@/pages/ResidentService'
import LegalZone from '@/pages/LegalZone'
import Unemploy from '@/pages/Unemploy'
import Training from '@/pages/Training'
import SkillCertList from '@/pages/SkillCertList'
import CreditManage from '@/pages/CreditManage'
import LaborRights from '@/pages/LaborRights'
import JobHunting from '@/pages/JobHunting'
import Internship from '@/pages/Internship'
import AccountInfo from '@/pages/AccountInfo'
import MyInfo from '@/pages/MyInfo'
import MyCertification from '@/pages/MyCertification'
import ECard from '@/pages/ECard'
import MySocial from '@/pages/MySocial'
import MyTraining from '@/pages/MyTraining'
import MyTodo from '@/pages/MyTodo'
import MyCert from '@/pages/MyCert'
import MyMaterial from '@/pages/MyMaterial'
import MyDoc from '@/pages/MyDoc'
import MyAddress from '@/pages/MyAddress'
import MyExpress from '@/pages/MyExpress'
import ShareApp from '@/pages/ShareApp'
import EnterpriseService from '@/pages/EnterpriseService'
import RightsRecordPrint from '@/pages/RightsRecordPrint'
import RightsRecordQuery from '@/pages/RightsRecordQuery'
import RightsRecordResult from '@/pages/RightsRecordResult'
import SocialInsuranceDetail from '@/pages/SocialInsuranceDetail'
import JiangsuPensionInsured from '@/pages/JiangsuPensionInsured'
import JiangsuSocialInsured from '@/pages/JiangsuSocialInsured'
import JobInternshipApply from '@/pages/JobInternshipApply'
import InternshipConfirm from '@/pages/InternshipConfirm'
import SubsidyApply from '@/pages/SubsidyApply'
import UnemployRegister from '@/pages/UnemployRegister'
import UnemployQuery from '@/pages/UnemployQuery'
import HardshipCertify from '@/pages/HardshipCertify'
import WorkRecordQuery from '@/pages/WorkRecordQuery'
import TrainingEvaluate from '@/pages/TrainingEvaluate'
import TrainingSubsidy from '@/pages/TrainingSubsidy'
import TrainingCertQuery from '@/pages/TrainingCertQuery'
import LoanApply from '@/pages/LoanApply'
import JobCertQuery from '@/pages/JobCertQuery'
import HardshipInfoQuery from '@/pages/HardshipInfoQuery'
import QualificationCertify from '@/pages/QualificationCertify'
import PensionAccountChange from '@/pages/PensionAccountChange'
import ServiceCustomize from '@/pages/ServiceCustomize'
import Splash from '@/pages/Splash'
import ScanVerify from '@/pages/ScanVerify'

Vue.use(Router)

// 登录门禁（游客模式）：未登录可浏览首页/服务/消息/小慧/我的等绝大多数页面，
// 仅进入涉及个人身份、账户、私人记录的功能时才要求先登录。
// 冷启动未登录先走 /splash 启动页，2.5s 或点「跳过」后进入首页。
const PROTECTED_PATHS = [
  // 账户与认证
  '/account-info', '/my-info', '/my-auth', '/show-cert', '/my-certification',
  '/settings', '/change-password', '/change-phone',
  // 电子社保卡
  '/e-card', '/social-card', '/social-card-query',
  // 「我的」个人中心各项
  '/my-social', '/my-training', '/my-todo', '/my-cert',
  '/my-material', '/my-doc', '/my-address', '/my-express',
  // 个人权益记录单（含查询表单/结果/多页明细）
  '/rights-record-print', '/rights-record-query', '/rights-record-result',
  '/social-insurance-detail', '/jiangsu-pension-insured', '/jiangsu-social-insured'
]

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/splash'
    },
    {
      // 冷启动启动页：未登录展示2.5s（可跳过），已登录直接进首页
      path: '/splash',
      name: 'Splash',
      component: Splash
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/message',
      name: 'Message',
      component: Message
    },
    {
      path: '/xiaohui',
      name: 'Xiaohui',
      component: Xiaohui
    },
    {
      path: '/mine',
      name: 'Mine',
      component: Mine
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/show-cert',
      name: 'ShowCert',
      component: ShowCert
    },
    {
      path: '/my-auth',
      name: 'MyAuth',
      component: MyAuth
    },
    {
      path: '/change-password',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/change-phone',
      name: 'ChangePhone',
      component: ChangePhone
    },
    {
      path: '/agreement-user',
      name: 'UserAgreement',
      component: DocPage,
      meta: {
        title: '用户协议',
        intro: '欢迎使用江苏智慧人社（以下简称“本应用”）。请您在使用前仔细阅读本协议，您点击同意即视为已充分理解并接受本协议全部内容。',
        sections: [
          { title: '协议范围', paras: ['本协议是您与江苏省人力资源和社会保障厅（以下简称“我们”）之间关于使用本应用提供的各项人社公共服务所订立的协议。'] },
          { title: '账号注册与使用', paras: ['您应使用本人真实身份信息完成注册、实名认证，并妥善保管账号及密码。因您主动泄露或遭受他人攻击导致的损失，由您自行承担。'], list: ['不得将账号转让、出借给他人使用；', '不得利用本应用从事任何违法违规活动；', '不得对本应用进行反向工程、破解或干扰系统正常运行。'] },
          { title: '服务内容', paras: ['本应用提供社会保障卡服务、社会保险查询与办理、就业创业、人才人事、劳动关系等人社公共服务，具体服务内容以应用内实际提供为准。'] },
          { title: '用户信息保护', paras: ['我们将依照《个人信息保护法》等法律法规及本应用《隐私政策》保护您的个人信息。'] },
          { title: '免责声明', paras: ['因系统维护、网络故障、不可抗力等非我方原因导致服务中断或数据延迟的，我们不承担相应责任。'] },
          { title: '协议修改', paras: ['我们有权根据法律法规及业务调整修订本协议，修订后的协议将在应用内公示，您继续使用即视为接受修订内容。'] }
        ]
      }
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: DocPage,
      meta: {
        title: '隐私政策',
        intro: '本应用重视并依法保护您的个人信息。本政策说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您享有的权利。',
        sections: [
          { title: '我们收集的信息', paras: ['为向您提供人社服务，我们可能收集以下信息：'], list: ['实名信息：姓名、身份证号、人脸特征信息（仅用于实人认证）；', '联系方式：手机号码；', '参保信息：参保单位、缴费记录、待遇信息等人社业务数据；', '设备信息：设备型号、操作系统版本、唯一设备标识，用于安全风控。'] },
          { title: '我们如何使用信息', list: ['完成实名认证、实人认证及业务办理身份核验；', '为您展示社保、就业等人社业务数据；', '保障账号与交易安全，防范欺诈风险；', '改进和优化产品服务体验。'] },
          { title: '信息的共享与对外提供', paras: ['除法律法规规定或获得您明示同意外，我们不会向第三方共享您的个人信息。具体共享情形请查阅《第三方信息共享清单》。'] },
          { title: '信息的存储与保护', paras: ['您的个人信息存储于中华人民共和国境内，我们采用加密传输、访问控制等安全技术措施，防止信息泄露、毁损或丢失。'] },
          { title: '您的权利', paras: ['您依法享有查阅、复制、更正、删除个人信息及撤回同意、注销账号等权利，可通过12333服务热线或应用内渠道行使。'] },
          { title: '政策更新与联系我们', paras: ['本政策可能适时更新，更新后将在应用内提示。如对本政策有任何疑问，可拨打12333人力资源社会保障服务热线咨询。'] }
        ]
      }
    },
    {
      path: '/privacy-summary',
      name: 'PrivacySummary',
      component: DocPage,
      meta: {
        title: '隐私政策摘要',
        intro: '为帮助您快速了解核心内容，我们将《隐私政策》要点摘要如下，完整内容请阅读《隐私政策》全文。',
        sections: [
          { title: '收集哪些信息', paras: ['为提供人社服务，我们会收集您的实名身份信息、手机号码、人脸特征信息及必要的参保业务数据和设备信息。'] },
          { title: '用来做什么', paras: ['仅用于实名认证、业务办理、数据展示和安全风控，不会用于与人社服务无关的用途。'] },
          { title: '是否共享', paras: ['除法律法规要求或您授权同意外，不向第三方共享您的个人信息，详见《第三方信息共享清单》。'] },
          { title: '如何保护', paras: ['信息境内存储，全程加密传输，采用严格的访问权限与安全审计机制。'] },
          { title: '您的权利', paras: ['您可随时查阅、更正、删除个人信息，撤回授权或注销账号，可拨打12333咨询或投诉。'] }
        ]
      }
    },
    {
      path: '/third-party-list',
      name: 'ThirdPartyList',
      component: DocPage,
      meta: {
        title: '第三方信息共享清单',
        intro: '为保障本应用相关功能的实现与安全运行，我们会向以下第三方SDK或服务提供必要信息。我们仅共享实现功能所必需的最小信息：',
        sections: [
          { title: '第三方共享明细', paras: [], table: {
            head: ['第三方', '共享信息', '使用目的'],
            rows: [
              ['人脸认证服务', '姓名、身份证号、人脸特征值', '完成实人认证、活体检测'],
              ['消息推送服务', '设备标识、推送令牌', '向您推送业务办理进度通知'],
              ['安全风控服务', '设备型号、操作系统、网络状态', '识别异常操作，保障账号安全'],
              ['地图定位服务', '位置信息（授权时）', '提供就近服务网点查询']
            ]
          } },
          { title: '说明', paras: ['以上第三方均依法承担个人信息保护责任，未经您授权不得将信息用于其他用途。清单将随业务变化及时更新。'] }
        ]
      }
    },
    {
      path: '/collected-info-list',
      name: 'CollectedInfoList',
      component: DocPage,
      meta: {
        title: '已收集个人信息清单',
        intro: '本清单向您列明本应用在提供服务过程中收集的个人信息类型及对应业务场景：',
        sections: [
          { title: '账号与认证类', list: ['姓名、身份证号码：注册登录、实名认证；', '手机号码：账号绑定、验证码核验、消息通知；', '人脸特征信息：实人认证、待遇资格认证。'] },
          { title: '人社业务类', list: ['参保登记信息、缴费记录；', '社会保障卡信息；', '就业失业登记、职业培训、技能鉴定信息；', '劳动用工备案、劳动保障投诉信息。'] },
          { title: '设备与日志类', list: ['设备型号、操作系统版本、设备标识符；', 'IP地址、操作日志、访问时间；', '位置信息（仅在您授权使用定位相关服务时）。'] },
          { title: '信息使用说明', paras: ['上述信息均在您使用对应功能时收集，拒绝提供非必要信息不影响其他功能的正常使用。'] }
        ]
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/social-card-query',
      name: 'SocialCardQuery',
      component: SocialCardQuery
    },
    {
      path: '/search',
      name: 'SearchPage',
      component: SearchPage
    },
    {
      path: '/pension',
      name: 'Pension',
      component: Pension
    },
    {
      path: '/rural-pension',
      name: 'RuralPension',
      component: RuralPension
    },
    {
      path: '/injury',
      name: 'Injury',
      component: Injury
    },
    {
      path: '/social-card',
      name: 'SocialCard',
      component: SocialCard
    },
    {
      path: '/one-thing',
      name: 'OneThing',
      component: OneThing
    },
    {
      path: '/case-list',
      name: 'CaseList',
      component: CaseList
    },
    {
      path: '/salary',
      name: 'Salary',
      component: Salary
    },
    {
      path: '/info-verify',
      name: 'InfoVerify',
      component: InfoVerify
    },
    {
      path: '/skill-cert',
      name: 'SkillCert',
      component: SkillCert
    },
    {
      path: '/computer-cert',
      name: 'ComputerCert',
      component: ComputerCert
    },
    {
      path: '/map-service',
      name: 'MapService',
      component: MapService
    },
    {
      path: '/graduate',
      name: 'Graduate',
      component: Graduate
    },
    {
      path: '/elderly',
      name: 'Elderly',
      component: Elderly
    },
    {
      path: '/resident-service',
      name: 'ResidentService',
      component: ResidentService
    },
    {
      path: '/legal-zone',
      name: 'LegalZone',
      component: LegalZone
    },
    {
      path: '/unemploy',
      name: 'Unemploy',
      component: Unemploy
    },
    {
      path: '/training',
      name: 'Training',
      component: Training
    },
    {
      path: '/skill-cert-list',
      name: 'SkillCertList',
      component: SkillCertList
    },
    {
      path: '/credit-manage',
      name: 'CreditManage',
      component: CreditManage
    },
    {
      path: '/labor-rights',
      name: 'LaborRights',
      component: LaborRights
    },
    {
      path: '/job-hunting',
      name: 'JobHunting',
      component: JobHunting
    },
    {
      path: '/internship',
      name: 'Internship',
      component: Internship
    },
    {
      path: '/account-info',
      name: 'AccountInfo',
      component: AccountInfo
    },
    {
      path: '/my-info',
      name: 'MyInfo',
      component: MyInfo
    },
    {
      path: '/my-certification',
      name: 'MyCertification',
      component: MyCertification
    },
    {
      path: '/e-card',
      name: 'ECard',
      component: ECard,
      // 设计稿为带关闭按钮的独立全屏页，隐藏底部导航
      meta: { hideTab: true }
    },
    {
      path: '/my-social',
      name: 'MySocial',
      component: MySocial
    },
    {
      path: '/my-training',
      name: 'MyTraining',
      component: MyTraining
    },
    {
      path: '/my-todo',
      name: 'MyTodo',
      component: MyTodo
    },
    {
      path: '/my-cert',
      name: 'MyCert',
      component: MyCert
    },
    {
      path: '/my-material',
      name: 'MyMaterial',
      component: MyMaterial
    },
    {
      path: '/my-doc',
      name: 'MyDoc',
      component: MyDoc
    },
    {
      path: '/my-address',
      name: 'MyAddress',
      component: MyAddress
    },
    {
      path: '/my-express',
      name: 'MyExpress',
      component: MyExpress
    },
    {
      path: '/share-app',
      name: 'ShareApp',
      component: ShareApp
    },
    {
      path: '/enterprise-service',
      name: 'EnterpriseService',
      component: EnterpriseService
    },
    {
      path: '/rights-record-print',
      name: 'RightsRecordPrint',
      component: RightsRecordPrint
    },
    {
      path: '/rights-record-query',
      name: 'RightsRecordQuery',
      component: RightsRecordQuery
    },
    {
      path: '/rights-record-result',
      name: 'RightsRecordResult',
      component: RightsRecordResult
    },
    {
      path: '/social-insurance-detail',
      name: 'SocialInsuranceDetail',
      component: SocialInsuranceDetail
    },
    {
      path: '/jiangsu-pension-insured',
      name: 'JiangsuPensionInsured',
      component: JiangsuPensionInsured
    },
    {
      path: '/jiangsu-social-insured',
      name: 'JiangsuSocialInsured',
      component: JiangsuSocialInsured
    },
    {
      path: '/job-internship-apply',
      name: 'JobInternshipApply',
      component: JobInternshipApply
    },
    {
      path: '/internship-confirm',
      name: 'InternshipConfirm',
      component: InternshipConfirm
    },
    {
      path: '/subsidy-apply',
      name: 'SubsidyApply',
      component: SubsidyApply
    },
    {
      path: '/unemploy-register',
      name: 'UnemployRegister',
      component: UnemployRegister
    },
    {
      path: '/unemploy-query',
      name: 'UnemployQuery',
      component: UnemployQuery
    },
    {
      path: '/hardship-certify',
      name: 'HardshipCertify',
      component: HardshipCertify
    },
    {
      path: '/work-record-query',
      name: 'WorkRecordQuery',
      component: WorkRecordQuery
    },
    {
      path: '/training-evaluate',
      name: 'TrainingEvaluate',
      component: TrainingEvaluate
    },
    {
      path: '/training-subsidy',
      name: 'TrainingSubsidy',
      component: TrainingSubsidy
    },
    {
      path: '/training-cert-query',
      name: 'TrainingCertQuery',
      component: TrainingCertQuery
    },
    {
      path: '/loan-apply',
      name: 'LoanApply',
      component: LoanApply
    },
    {
      path: '/job-cert-query',
      name: 'JobCertQuery',
      component: JobCertQuery
    },
    {
      path: '/hardship-info-query',
      name: 'HardshipInfoQuery',
      component: HardshipInfoQuery
    },
    {
      path: '/qualification-certify',
      name: 'QualificationCertify',
      component: QualificationCertify
    },
    {
      path: '/pension-account-change',
      name: 'PensionAccountChange',
      component: PensionAccountChange
    },
    {
      path: '/service-customize',
      name: 'ServiceCustomize',
      component: ServiceCustomize
    },
    {
      path: '/labor-dispute-mediation',
      name: 'LaborDisputeMediation',
      component: LaborDisputeMediation
    },
    {
      path: '/verify',
      name: 'ScanVerify',
      component: ScanVerify
    },
    // 服务模块通用子页：按 svcPages 配置批量注册（SvcPage 依据 $route.meta 渲染表单/查询/列表）
    ...svcPages.map(c => ({ path: c.path, component: SvcPage, meta: c }))
  ]
})

// 扫码分享托管环境（Cloudflare Pages，https 且非本机）：
// 白名单模式——他人扫码只能访问 /verify 点选验证页和两个权益记录单页，
// 其他任何路径（首页/登录/我的等）一律不可达。验证通过后带 v 时间戳凭证
// （30 分钟有效）落地筛选好的权益记录单，无需登录。
// APK 内为 file:// 协议、本地开发为 localhost，均不受影响。
const SHARE_PATHS = ['/jiangsu-pension-insured', '/jiangsu-social-insured']
// 白名单外路径被拦截时的兜底落地页（验证后展示）
const SHARE_FALLBACK_PATH = '/jiangsu-pension-insured'
function isShareHost() {
  return location.protocol.indexOf('http') === 0 &&
    location.hostname !== 'localhost' &&
    location.hostname !== '127.0.0.1'
}

// 登录门禁：游客可浏览，仅命中个人敏感功能清单时才拦截到登录页，
// 登录一次后（本地记录登录态）不再拦截，直到「退出登录」确认清除登录态
router.beforeEach((to, from, next) => {
  if (isShareHost()) {
    // 验证页本身始终放行
    if (to.path === '/verify') {
      next()
      return
    }
    if (SHARE_PATHS.indexOf(to.path) !== -1) {
      // 已带 30 分钟内的验证凭证则直接放行，否则先去人工点选验证
      const v = Number(to.query.v)
      if (v && Date.now() - v < 30 * 60 * 1000) {
        next()
        return
      }
      next({ path: '/verify', query: { redirect: to.fullPath } })
      return
    }
    // 白名单外的任何页面：重定向到验证页，验证后走兜底落地页
    next({ path: '/verify', query: { redirect: SHARE_FALLBACK_PATH } })
    return
  }
  const loggedIn = localStorage.getItem('jszhrs_logged_in') === '1'
  if (!loggedIn && PROTECTED_PATHS.indexOf(to.path) !== -1) {
    next('/login')
    return
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js